import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { MonthlyVisitors, Website } from "@/api/types"

export function monthlyVisitorsOptions(website: Website, months: number) {
	return queryOptions({
		queryKey: ["analytics", website, "monthly", months],
		queryFn: (): Promise<MonthlyVisitors[]> =>
			GET("/api/v1/analytics/{website}/monthly", {
				params: { path: { website }, query: { months } },
			}),
	})
}

export function useMonthlyVisitors(website: Website, months: number) {
	return useQuery(monthlyVisitorsOptions(website, months))
}
